import { useTranslation } from 'react-i18next'
import { TimelineFilter as CommonTimelineFilter } from '../../common/Filter/TimelineFilter/TimelineFilter'
import {
    FilterProps,
    FilterTypeTimelineProps,
    TimelineFilterValue,
} from '../../common/Filter/types'
import { useFilterLabels } from './useFilterLabels'

type TimelineFilterProps = {
    name: string
    onChange: (commodityType: TimelineFilterValue) => void
    value: TimelineFilterValue
    defaultValue: TimelineFilterValue
    disabled?: boolean
} & Pick<FilterProps, 'containerRef'>

export const TimelineFilter: React.FC<TimelineFilterProps> = (props) => {
    const { disabled, name, value, defaultValue, onChange } = props
    const labels = useFilterLabels()
    const { t } = useTranslation('translations')

    const passedProps: FilterTypeTimelineProps = {
        name,
        disabled,
        label: t(`filters.timeline.label`),
        ...labels,
        config: {
            value,
            options: [
                {
                    value: 'not-a-real-option',
                    label: 'Not a real option',
                },
            ],
        },
        onChange,
        value,
        defaultValue,
        containerRef: props.containerRef,
    }

    return <CommonTimelineFilter {...passedProps} />
}
